import {Component, Input, OnChanges} from '@angular/core';

import {StudentService} from '../../services/student.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {InterventionLogDto} from '@sidr/dto-types';
import {StudentIntvlogDialogComponent} from './intvlog.modal';

@Component({
  selector: `student-intvlog`,
  templateUrl: 'student.intvlog.component.html'
})
export class StudentIntvLogComponent implements OnChanges {
  intvlogs: InterventionLogDto[];
  intvlog: InterventionLogDto;
  @Input() printOptions: PrintOptions;
  @Input() districtId: string;
  @Input() studentId: string;

  getData() {
    if (!this.districtId || !this.studentId) {
      return;
    }
    this.studentService.getInterventionLogs(this.districtId, this.studentId).subscribe(resp => {
      this.intvlogs = resp || [];
      if (this.intvlogs !== null) {
        this.intvlogs.sort((a: InterventionLogDto, b: InterventionLogDto) => {
          return a.date > b.date ? -1 : 1;
        });
      }
    }, () => {
      this.intvlogs = [];
    });
  }

  ngOnChanges(): void {
    this.getData();
  }

  today(): string {
    const now = new Date(Date.now());
    let month = (now.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = now.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }
    return `${now.getFullYear()}-${month}-${day}`;
  }

  new() {
    const m = this.modal.open(StudentIntvlogDialogComponent, {
      size: 'lg',
      centered: true,
    });

    m.componentInstance.log = {} as InterventionLogDto;
    m.componentInstance.edit = true;
    m.componentInstance.log.date = this.today();
    m.componentInstance.studentId = this.studentId;
    m.componentInstance.districtId = this.districtId;
    m.result.then(r => {
      if (r) {
        this.getData();
      }
    }, reason => {
      if (reason) {
        this.getData();
      }
    });
  }

  open(i: InterventionLogDto) {
    const m = this.modal.open(StudentIntvlogDialogComponent, {
      size: 'lg'
    });
    m.componentInstance.log = {...i};
    m.componentInstance.studentId = this.studentId;
    m.componentInstance.districtId = this.districtId;

    m.result.then(r => {
      if (r) {
        this.getData();
      }
    }, reason => {
      if (reason) {
        this.getData();
      }
    });
  }

  constructor(private studentService: StudentService, private modal: NgbModal) {
    this.intvlogs = [];
    this.intvlog = {} as InterventionLogDto;
  }
}
